export default {"src":"/_next/static/media/red_error_bang.4126ae11.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};